import mixinActions from '../core/actions';
import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';
import axios from 'axios';
import Vue from 'vue';
import constants from 'Helpers/constants';
import utils from 'Helpers/utils';

export default {
    namespaced: true,
    state: {
        event: {},
        ou: [],
        hdp: [],
        cornersOu: [],
        cornersHdp: [],
        wld: [],
        btts: [],
        dc: [],
        cs: [],
        ou1h: [],
        hdp1h: [],
        cornersOu1h: [],
        cornersHdp1h: [],
        wld1h: [],
        btts1h: [],
        dc1h: [],
        cs1h: [],
        events: [],
        stats: {},
        repositoryName: 'events',
        betFeedData: {},
    },
    mutations: {
        ...mixinMutations(),
        setEvent(state, event) {
            state.event = event;
        },
        setOu(state, prices) {
            state.ou = prices;
        },
        setOu1h(state, prices) {
            state.ou1h = prices;
        },
        setCornersOu(state, prices) {
            state.cornersOu = prices;
        },
        setCornersOu1h(state, prices) {
            state.cornersOu1h = prices;
        },
        setHdp(state, prices) {
            state.hdp = prices;
        },
        setCornersHdp(state, prices) {
            state.cornersHdp = prices;
        },
        setBtts(state, prices) {
            state.btts = prices;
        },
        setDc(state, prices) {
            state.dc = prices;
        },
        setCs(state, prices) {
            state.cs = prices;
        },
        setHdp1h(state, prices) {
            state.hdp1h = prices;
        },
        setCornersHdp1h(state, prices) {
            state.cornersHdp1h = prices;
        },
        setWld(state, prices) {
            state.wld = prices;
        },
        setWld1h(state, prices) {
            state.wld1h = prices;
        },
        setBtts1h(state, prices) {
            state.btts1h = prices;
        },
        setDc1h(state, prices) {
            state.dc1h = prices;
        },
        setCs1h(state, prices) {
            state.cs1h = prices;
        },
        setStats(state, stats) {
            state.stats = stats;
        },
        setBetFeedData(state, data) {
            if (data.betFeedData === null) {
                Vue.delete(state.betFeedData, data.idx);
            } else {
                Vue.set(state.betFeedData, data.idx, data.betFeedData);
            }
        },
        setBetFeedDataDefault(state) {
            state.betFeedData = {};
        },
    },
    getters: {
        ...mixinGetters(),
        getEvent(state) {
            return state.event;
        },
        getOu(state) {
            return state.ou;
        },
        getOu1h(state) {
            return state.ou1h;
        },
        getCornersOu(state) {
            return state.cornersOu;
        },
        getCornersOu1h(state) {
            return state.cornersOu1h;
        },
        getHdp(state) {
            return state.hdp;
        },
        getHdp1h(state) {
            return state.hdp1h;
        },
        getCornersHdp(state) {
            return state.cornersHdp;
        },
        getCornersHdp1h(state) {
            return state.cornersHdp1h;
        },
        getWld(state) {
            return state.wld;
        },
        getWld1h(state) {
            return state.wld1h;
        },
        getBtts(state) {
            return state.btts;
        },
        getBtts1h(state) {
            return state.btts1h;
        },
        getDc(state) {
            return state.dc;
        },
        getDc1h(state) {
            return state.dc1h;
        },
        getCs(state) {
            return state.cs;
        },
        getCs1h(state) {
            return state.cs1h;
        },
        getStats(state) {
            return state.stats;
        },
        getBetFeedData(state) {
            return state.betFeedData;
        },
    },
    actions: {
        ...mixinActions('notification'),

        resetPrices(context) {
            context.dispatch('EventModule/resetPricesFT', null, {root: true});
            context.dispatch('EventModule/resetPrices1H', null, {root: true});
        },

        resetPricesFT(context) {
            context.commit('setOu', []);
            context.commit('setHdp', []);
            context.commit('setCornersOu', []);
            context.commit('setCornersHdp', []);
            context.commit('setWld', []);
            context.commit('setBtts', []);
            context.commit('setDc', []);
            context.commit('setCs', []);
        },

        resetPrices1H(context) {
            context.commit('setOu1h', []);
            context.commit('setHdp1h', []);
            context.commit('setCornersOu1h', []);
            context.commit('setCornersHdp1h', []);
            context.commit('setWld1h', []);
            context.commit('setBtts1h', []);
            context.commit('setDc1h', []);
            context.commit('setCs1h', []);
        },

        resetBetFeedData(context, params) {
            context.commit('setBetFeedDataDefault');
        },

        updateEventPopup(context, data) {
            //check if Event popup still be opened. We can receive update after popup closing
            if (Object.keys(context.state.event).length === 0) {
                return;
            }
            //empty data when event is finished
            if (!data) {
                return;
            }

            if (data['custom_event_id'] !== context.state.event.ceId) {
                console.log('Received wrong Custom Event Id. Received #' + data['custom_event_id'] + ' but current is #' + context.state.event.ceId);
                return;
            }

            let base, stats;
            if ('ft' in data) {
                base = data['ft'].base;
                stats = data['ft'].stats;
                context.commit('setWld', data['ft'].market1x2);
                context.commit('setBtts', data['ft'].marketBtts);
                context.commit('setDc', data['ft'].marketDc);
                context.commit('setCs', data['ft'].marketCs);
                context.commit('setOu', data['ft'].marketGoal);
                context.commit('setHdp', data['ft'].marketHandicap);
                context.commit('setCornersOu', data['ft'].marketCornersGoal);
                context.commit('setCornersHdp', data['ft'].marketCornersHandicap);
            } else {
                context.dispatch('EventModule/resetPricesFT', null, {root: true});
            }

            if ('1h' in data) {
                base = base ?? data['1h'].base;
                stats = stats ?? data['1h'].stats;
                context.commit('setWld1h', data['1h'].market1x2);
                context.commit('setBtts1h', data['1h'].marketBtts);
                context.commit('setDc1h', data['1h'].marketDc);
                context.commit('setCs1h', data['1h'].marketCs);
                context.commit('setOu1h', data['1h'].marketGoal);
                context.commit('setHdp1h', data['1h'].marketHandicap);
                context.commit('setCornersOu1h', data['1h'].marketCornersGoal);
                context.commit('setCornersHdp1h', data['1h'].marketCornersHandicap);
            } else {
                context.dispatch('EventModule/resetPrices1H', null, {root: true});
            }

            if(base) {
                let event = Object.assign({}, context.state.event, {
                    leftUntilStart: base.leftUntilStart,
                    mId: base.source_id,
                });
                Vue.set(context.state, 'event', event);
                //stats are empty for dball event
                if(stats) {
                    context.commit('setStats', stats);
                }
            }

            // this.updateBetDialog(context)
            context.dispatch('updateBetDialog');
        },

        updateBetDialog(context) {
            //if was opened bet popup need to update data
            if (_.isEmpty(context.state.betFeedData) === false) {
                for (let index in context.state.betFeedData) {
                    let betFeedData = context.state.betFeedData[index];

                    let marketKey = '';

                    if (betFeedData['betTypeId'] === constants.BET_TYPE_1X2) {
                        marketKey = 'wld';
                    } else if (betFeedData['betTypeId'] === constants.BET_TYPE_BTTS) {
                        marketKey = 'btts';
                    } else if (betFeedData['betTypeId'] === constants.BET_TYPE_HANDICAP) {
                        marketKey = 'hdp';
                    } else if (betFeedData['betTypeId'] === constants.BET_TYPE_GOAL) {
                        marketKey = 'ou';
                    } else if (betFeedData['betTypeId'] === constants.BET_TYPE_CORNERS_HANDICAP) {
                        marketKey = 'cornersHdp';
                    } else if (betFeedData['betTypeId'] === constants.BET_TYPE_CORNERS_GOAL) {
                        marketKey = 'cornersOu';
                    } else if (betFeedData['betTypeId'] === constants.BET_TYPE_DC) {
                        marketKey = 'dc';
                    } else if (betFeedData['betTypeId'] === constants.BET_TYPE_CS) {
                        marketKey = 'cs';
                    }

                    if (betFeedData['periodTypeId'] === constants.GAME_PERIOD_1H) {
                        marketKey += '1h';
                    }

                    let price = context.state[marketKey];

                    if (price instanceof Array) {
                        //hdp or ou
                        price = price.find(
                            (feed) =>
                                feed.custom_event_id == betFeedData.ceId &&
                                ((betFeedData['betTypeId'] !== constants.BET_TYPE_HANDICAP  && betFeedData['betTypeId'] !== constants.BET_TYPE_CORNERS_HANDICAP) ||
                                    feed[betFeedData['handicapKey']] == 0 ||
                                    feed.jollywhere === betFeedData.market.jw) &&
                                (betFeedData.market.handicap === null || feed[betFeedData.handicapKey] === betFeedData.market.handicap) &&
                                !_.isNull(feed[betFeedData.oddsMaxKey]) &&
                                feed[betFeedData.oddsMaxKey] !== undefined &&
                                (betFeedData['betTypeId'] !== constants.BET_TYPE_CS || feed.score === betFeedData['correctScore'])
                        );
                    }

                    if (price) {
                        //need to convert str to array and skip price id - data[1]
                        let oddsListKey = betFeedData['oddsListKey'];

                        //skip reactivity
                        let priceCopy = JSON.parse(JSON.stringify(price));
                        priceCopy[oddsListKey] = JSON.parse(priceCopy[oddsListKey]).map((data) => [data[0], data[2]]);

                        betFeedData['time'] = context.state.stats.time ?? null;
                        betFeedData['sc'] = context.state.stats.score ?? null;
                        betFeedData['corners'] = utils.isValidNumber(context.state.stats.corners_home) ? (context.state.stats.corners_home + '-' + context.state.stats.corners_away) :  null;
                        betFeedData['marketId'] = context.state.event.mId;
                        betFeedData['market'] = utils.extractPriceData(
                            priceCopy,
                            betFeedData.handicapKey,
                            betFeedData.oddsMaxKey,
                            betFeedData.betTypeId,
                            betFeedData.oddsListKey
                        );
                        betFeedData.isActive = true;
                    } else {
                        betFeedData.isActive = false;
                    }

                    // context.state.betFeedData = { idx: index, betFeedData: betFeedData };
                    Vue.set(context.state.betFeedData, index, betFeedData);
                }
            }
        },

        updateBettingPopup(context, data) {
            if ('maxStake' in data && data.maxStake !== null) {
                Object.keys(data.maxStake).forEach((uuid) => {
                    Object.keys(context.state.betFeedData).forEach((id) => {
                        if (context.state.betFeedData[id].uuid == uuid) {
                            let oddsMaxStake = context.state.betFeedData[id].oddsMaxStake ?? {};
                            let update = {
                                ...oddsMaxStake,
                                ...data['maxStake'][uuid],
                            };
                            Vue.set(context.state.betFeedData[id], 'oddsMaxStake', update);
                        }
                    });
                });
            }

            if ('extraOdds' in data && data.extraOdds !== null) {
                Object.keys(data.extraOdds).forEach((uuid) => {
                    Object.keys(context.state.betFeedData).forEach((id) => {
                        if (context.state.betFeedData[id].uuid == uuid) {
                            Object.keys(data['extraOdds'][uuid]).forEach((siteId) => {
                                let extraOddsLinesCount = Object.keys(data['extraOdds'][uuid][siteId]).length;
                                if (
                                    !context.state.betFeedData[id]['extraOddsLinesCount'] ||
                                    context.state.betFeedData[id]['extraOddsLinesCount'] < extraOddsLinesCount
                                ) {
                                    Vue.set(context.state.betFeedData[id], 'extraOddsLinesCount', extraOddsLinesCount);
                                }
                            });

                            Vue.set(context.state.betFeedData[id], 'extraOdds', data['extraOdds'][uuid]);
                        }
                    });
                });
            }
        },
    },
};
